module.exports = __webpack_public_path__ + "static/media/bg-login-skyEX.d41d8cd9.webp";